import React from 'react';

import Snackbar from '@material-ui/core/Snackbar';

export default class ErrorMsg extends React.Component {

    componentDidMount() {

    }

    render() {
        return (
            <div className="limite">
            <div style={{
                display: (this.props.globalError ? "block" : "none"),
                margin: "20px",
                padding: "20px",
                textAlign: "left",
                backgroundColor: "rgb(255, 209, 209)",
                color: "red"
            }}>
                <div dangerouslySetInnerHTML={{ __html: this.props.globalError }} >
                </div>

                <Snackbar
                    ContentProps={{
                        style: {
                            backgroundColor: "#d32f2f",
                            color: "#fff"
                        }
                    }}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={!!this.props.globalError}

                    message={<span id="message-id"><div dangerouslySetInnerHTML={{ __html: this.props.globalError }} >
                    </div></span>}
                />
            </div>
            <div style={{
                display: (this.props.globalMsg ? "block" : "none"),
                margin: "20px",
                padding: "20px",
                textAlign: "left",
                backgroundColor: "rgb(211, 243, 198)",
                color: "green"
            }}>
                <div dangerouslySetInnerHTML={{ __html: this.props.globalMsg }} >
                </div>

                <Snackbar
                    ContentProps={{
                        style: {
                            backgroundColor: "rgb(0, 144, 54)",
                            color: "#fff"
                        }
                    }}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={!!this.props.globalMsg}

                    message={<span id="message-id2"><div dangerouslySetInnerHTML={{ __html: this.props.globalMsg }} >
                    </div></span>}
                />
            </div>

            </div>
        );
    }


};